var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuoteLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 82.9888,
    y1: 250.3258,
    x2: 418,
    y2: 250.3258
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.002180233,
    style: {
      stopColor: "#009EE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7DB828"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M146.42,242.52v12.08c0,43.97,20.14,68.97,60.42,75.01v52.36c-34.23-1.01-60.57-7.98-79.04-20.89 c-18.47-12.92-30.56-29.45-36.25-49.59c-5.69-20.14-8.56-48.5-8.56-85.08V118.68h123.84v123.84H146.42z M358.09,242.52 c-0.35,5.37-0.5,9.39-0.5,12.08c0,43.97,20.14,68.97,60.41,75.01v52.36c-34.04-1.01-60.41-7.98-79.12-20.89 c-18.7-12.92-30.82-29.45-36.4-49.59c-5.54-20.14-8.32-48.5-8.32-85.08V118.68H418v123.84H358.09z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteLeft);
export default __webpack_public_path__ + "static/media/quote_left.aa611bb64d9e4ea1e7f361b683ceaa92.svg";
export { ForwardRef as ReactComponent };